import type { IdentityInfo } from "owa-auth-types";
import { mutatorAction } from "satcheljs";
import { getIdentityKeyForIdentityInfo } from "owa-auth-types";
import getStore from "../store/Store";
import { StateTypeEnum } from "../store/schema/AccountAuthState";

/**
 * Marks the identity as removed in the current session. This is used when the user removes an account
 * that requires a restart.
 * @param identityInfo The identity info of the account to mark as removed in session
 */
const markIdentityAsRemovedThisSessionMutator: (identityInfo: IdentityInfo) => void = mutatorAction("MARK_IDENTITY_AS_REMOVED_THIS_SESSION", function (identityInfo: IdentityInfo): void {
    const removedAccountAuthState = {
        stateType: StateTypeEnum.AuthError,
        errorData: {
            timeStamp: Date.now(),
            error: "Account removed from session",
        },
        isReplacedInSession: true,
    };
    
    const states = getStore().accountAuthStates;
    states.set(getIdentityKeyForIdentityInfo(identityInfo), removedAccountAuthState);
});

export default markIdentityAsRemovedThisSessionMutator;
